import { http } from '../../config/axios'

export default function patchPlano(idPlano: string, idCliente:string): Promise<string> {
  return http
    .patch('api/plano/customizar/'+idPlano+'/'+idCliente)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro patchPlano', error)
      throw Error(error.response.data)
    })
}
